import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import RequireLoggedIn from "./RequireAuth";

/**
 * Alleen de contract-eigenaar mag het commissie-dashboard zien. De backend
 * hanteert dezelfde allowlist op de /commission-endpoints, dus dit is puur
 * de UI-kant van de afscherming.
 */
export const COMMISSION_OWNER_EMAILS = ["ralphbogaert1@gmail.com"];

export default function RequireCommissionOwner() {
  const { user } = useAuth();

  if (
    user &&
    !COMMISSION_OWNER_EMAILS.includes((user.email ?? "").toLowerCase())
  ) {
    return <Navigate to="/" replace />;
  }

  return <RequireLoggedIn />;
}
